import { useState } from 'react';
import { Paper } from '@mui/material';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import MDTypography from 'components/MDTypography';

/**
 * Draggable item component for the sidebar
 */
export function SideBarItem({ item, onDragStart, collapsable }) {
  const [elevation, setElevation] = useState(1);

  const handleMouseEnter = () => {
    setElevation(4);
  };

  const handleMouseLeave = () => {
    setElevation(1);
  };

  const handleDragStart = (event) => {
    if (item.disabled) {
      event.preventDefault();
      return;
    }
    onDragStart(event, item);
  };

  return (
    <Paper
      elevation={elevation}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onDragStart={handleDragStart}
      draggable
      sx={{
        cursor: item.disabled ? 'not-allowed' : 'grab',
        display: 'flex',
        alignItems: 'center',
        p: collapsable ? 1 : 2,
        pl: collapsable ? 4 : 2,
        border: collapsable ? 'none' : '1px solid',
        borderTop: collapsable ? '1px solid' : undefined,
        borderColor: (theme) => `${theme.palette[item.color].main}33`,
        opacity: item.disabled ? 0.5 : 1,
        transition: 'box-shadow 0.3s ease-in-out',
        borderRadius: '5px !important',
        backgroundColor: (theme) => `${theme.palette[item.color].main}11 !important`
      }}
    >
      <Icon fontSize="medium" color={item.color}>
        {item.icon}
      </Icon>
      <Tooltip title={item.label}>
        <MDTypography
          fontSize="0.85rem"
          ml={1}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '145px'
          }}
        >
          {item.label}
        </MDTypography>
      </Tooltip>
      {item.disabled && (
        <MDTypography ml={1} variant="caption" color="error" fontSize="0.7rem">
          (1 max.)
        </MDTypography>
      )}
    </Paper>
  );
}

SideBarItem.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  }).isRequired,
  onDragStart: PropTypes.func.isRequired,
  collapsable: PropTypes.bool
};
